import React from 'react';
import { Alert } from 'react-bootstrap';

interface CompanySettlement {
  name?: string | null;
  monthlySettlement?: boolean | null;
  invoicesSettlement?: boolean | null;
}

interface Props {
  company: CompanySettlement | null | undefined;
}

export const CompanyPrepaymentAlert: React.FC<Props> = ({ company }) => {
  if (!company?.name) {
    return null;
  }

  if (company.monthlySettlement || company.invoicesSettlement) {
    return null;
  }

  return (
    <Alert variant="warning">
      Wymaga płatności z góry. Firma nie jest rozliczana miesięcznie/fakturowo.
    </Alert>
  );
};
